<template>
  <div class="place-form">
    <vue-autosuggest
      ref="autosuggest"
      :class="place-autosuggest"
      :suggestions="suggestions"
      :get-suggestion-value="getSuggestionValue"
      :input-props="{id:'autosuggest__input', class: 'form-control', onInputChange: onInputChange, placeholder:'Search...'}"
      @selected="clickHandler">
      <template slot-scope="{suggestion}">
        <img v-if="suggestion && suggestion.item.categories[0]" class="avatar" :src="suggestion.item.categories[0].icon.prefix + 'bg_32' + suggestion.item.categories[0].icon.suffix"/>
        <img v-else class="avatar" src="../assets/map-marker-alt-solid.svg"/>
        <span class="suggestion-item">
          {{suggestion.item.name}}
          <span class="address">{{ suggestion.item.location.address }}</span>
        </span>
      </template>
    </vue-autosuggest>
    <b-button :disabled="!hasValue" @click.prevent="addItem" class="new-place" variant="info">
      <fa-icon icon="plus"></fa-icon>
    </b-button>
  </div>
</template>

<script>
  import { VueAutosuggest } from 'vue-autosuggest';
  import VenueService from '@/services/VenueService';
  import * as axios from 'axios';

  export default {
    name: 'venue-search',
    data: function() {
      return {
        suggestions: [],
        minLength: 1,
        selectedItem: null,
        currentSearchTerm: null,
        place: null,
        autosuggest: null
      }
    },
    components: {
      VueAutosuggest
    },
    computed: {
      hasValue: function() {
        return this.selectedItem !== null || (this.currentSearchTerm !== '' && this.currentSearchTerm != null);
      }
    },
    methods: {
      clickHandler: function(selected) {
        if (!selected) {
          this.addItem();
          this.$refs.autosuggest.searchInput = "";
        } else {
          const item = selected.item;
          VenueService.createVenue({
            name: item.name,
            lat: item.location.lat,
            lng: item.location.lng,
            address: this.formatAddress(item),
            notes: [],
            visited: false,
            created: new Date(),
            foursquare_id: item.id
          }).then(() => {
            this.$refs.autosuggest.searchInput = "";
          });
        }
      },
      formatAddress: function(item) {
        const location = item.location;
        const cityState = `${location.city}, ${location.state}`;
        let finalAddress = cityState;
        if (location.address) {
          finalAddress = `${location.address}, ${finalAddress}`;
        }
        if (location.postalCode) {
          finalAddress = `${finalAddress} ${location.postalCode}`;
        }
        return finalAddress;
      },
      onInputChange: function(term) {
        this.search(term);
        this.currentSearchTerm = term;
      },
      getSuggestionValue(val) {
        return val.item.name;
      },
      addItem() {
        this.suggestions = [];
        VenueService.createVenue({
          name: this.currentSearchTerm,
          notes: [],
          visited: false,
          created: new Date()
        });
      },
      search: function(term) {
        if (term && term.length > this.minLength) {
          axios.get('https://api.foursquare.com/v2/venues/search', {
            params: {
              near: "Denver, CO",
              query: term,
              limit: 10,
              client_secret: process.env.VUE_APP_FOURSQUARE_CLIENT_SECRET,
              client_id: process.env.VUE_APP_FOURSQUARE_CLIENT_ID,
              v: '20181013'
            }
          })
          .then((resp) => {
            this.suggestions = [
              {data: resp.data.response.venues}
            ];
          })
          .catch((err) => {
            console.log(err);
          })
        } else {
          this.suggestions = [];
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .place-form {
    display: flex;
    justify-content: center;
    button.new-place {
      border-radius: 0 5px 5px 0;
    }
  }
  #autosuggest {
    width: 100%;
  }
</style>

<style lang="scss">
    /*
    Autocomplete Stuff

    Why did I copy all these in here?
    */
    #autosuggest__input {
      outline: none;
      display: block;
      font-size: 20px;
      // border: 1px solid #616161;
      border-radius: 5px 0 0 5px;
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }

    .suggestion-item {
      .address {
        color: #999;
        font-size: .75em;
      }
    }

    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }

    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }

    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }

    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }

    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }

    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }

    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #ddd;
    }

    .avatar {
        width: 25px;
        height: 25px;
        border-radius: 15px;
        margin-right: 10px;
    }

</style>
